import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

global.APPLICATION_THEME = undefined as unknown as ApplicationTheme;

const renderReact = () => {
  ReactDOM.render(
    <App />,
    document.getElementById('root'),
  );
};

if (!REGISTRY_ENVIRONMENT_VARIABLES.themeFile) {
  renderReact();
} else {
  const themeScript = document.createElement('script');
  themeScript.setAttribute('src', `${process.env.PUBLIC_URL}/themes/${REGISTRY_ENVIRONMENT_VARIABLES.themeFile}`);
  themeScript.async = false;

  document.head.append(themeScript);

  themeScript.onload = renderReact;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
